// Vendor Imports
import { Component, OnInit,HostListener } from "@angular/core";
import { UserIdleService } from "angular-user-idle";
import { Router } from "@angular/router";
// import { Component, HostListener } from '@angular/core';
@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.css"]
})
export class AppComponent implements OnInit {
  title = "ima-admin";
  
  constructor(private userIdle: UserIdleService, private router: Router) { }

  ngOnInit() {
    //Start watching for user inactivity.
    // this.userIdle.startWatching();

    // this.userIdle.onTimerStart().subscribe();

    // // Start watch when time is up.
    // this.userIdle.onTimeout().subscribe(() => {
    //   localStorage.clear();
    //   // this.router.navigate(["/login"]);
    //   this.restart();
    // });
  }
  // @HostListener('contextmenu', ['$event'])
  // onRightClick(event: MouseEvent) {
  //   event.preventDefault();
  // }

  // Disable Developer Tools Shortcuts
  // Disable Inspect button
  // @HostListener('window:keydown', ['$event'])
  // disableDevTools(event: KeyboardEvent) {
  //   if (
  //     event.key === 'F12' || 
  //     (event.ctrlKey && event.shiftKey && (event.key === 'I' || event.key === 'J' || event.key === 'C')) || 
  //     (event.ctrlKey && event.key === 'U')
  //   ) {
  //     event.preventDefault();
  //   }
  // }

  stop() {
    this.userIdle.stopTimer();
  }

  stopWatching() {
    this.userIdle.stopWatching();
  }

  startWatching() {
    this.userIdle.startWatching();
  }

  restart() {
    this.userIdle.resetTimer();
  }
}
